import { css, type Theme } from "@emotion/react";

export const fullWidth = css`
  width: 100%;
`;

export const buttonHeight = (theme: Theme) => css`
  height: ${theme.ds5.button.height.medium};
  min-height: ${theme.ds5.button.height.medium};
`;
